/** @format */

export function getPhoneNumberFromString(string) {
  const numb = string.match(/\d/g);
  return numb.join('');
}
